import { DataService } from '../services/data_service';
import { i18n } from '../i18n/i18n';
import { IDs } from '../helpers/IDs';
import { lazyInject } from '../services/inversify';
import parse from 'html-react-parser';
import * as React from 'react';

interface InfoDialogProps extends React.ClassAttributes<any> {
    name: string;
}

interface InfoDialogState extends React.ClassAttributes<any> {
    content: any;
}

export class InfoDialog extends React.Component<InfoDialogProps, InfoDialogState> {

    constructor(props: any) {
        super(props);
        this.state = {
            content: undefined
        };
    }

    @lazyInject(DataService) private dataService: DataService;

    componentDidMount(): void {
        this.dataService.loadDataForModul(
            IDs.ENT_SYSTEMTEXTE, { name: this.props.name }, {}, IDs.MOD_ETOOL_ADMIN,
            (result: any) => {
                if (result.systemtexte && result.systemtexte && result.systemtexte[0] && result.systemtexte[0].beschreibung) {
                    const content = parse(result.systemtexte[0].beschreibung);
                    this.setState({ content });
                } else {
                    this.setState({ content: <div>{i18n("Infotext '{{1}}' nicht gefunden", 'sys').replace('{{1}}', this.props.name)}</div> });
                }
            }
        );
    }

    render(): JSX.Element {
         return (
            <div style={{ margin: '0 0 20px 20px', paddingTop: 10, paddingRight: 20, overflow: 'hidden auto' }}>
                {this.state.content || <div>{i18n('Lade', 'sys')}...</div>}
            </div>
        );
    }
}
